import SometurvaLogo from "images/logo-someturva.svg"
import SomebuddyLogo from "images/logo-somebuddy.svg"
import SometurvaLogoBW from "images/logo-someturva-bw.svg"
import SomebuddyLogoBW from "images/logo-somebuddy-bw.svg"
import LogoSomebuddyPro from "images/logo-somebuddy-pro.svg"
import LogoSometurvaPro from "images/logo-someturva-pro.svg"
import LogoSomebuddyProBW from "images/logo-somebuddy-pro-bw.svg"
import LogoSometurvaProBW from "images/logo-someturva-pro-bw.svg"

import { siteCountry } from "utils/env"

const logoByCountry = {
  global: SomebuddyLogo,
  se: SomebuddyLogo,
  fi: SometurvaLogo,
}

export const getLogoByCountry = () => logoByCountry[siteCountry]

const footerLogoByCountry = {
  global: SomebuddyLogoBW,
  se: SomebuddyLogoBW,
  fi: SometurvaLogoBW,
}

const footerLogoByRoute = {
  global: {
    "/pro": LogoSomebuddyProBW,
    "/pro/trainings": LogoSomebuddyProBW,
  },
  fi: {
    "/schools": SometurvaLogo,
    "/pro": LogoSometurvaProBW,
    "/pro/trainings": LogoSometurvaProBW,
    "/pro/onboarding": LogoSometurvaProBW,
  },
  se: {
    "/schools": SomebuddyLogo,
  },
}

const headerLogoByRoute = {
  global: {
    "/pro": LogoSomebuddyPro,
    "/pro/trainings": LogoSomebuddyPro,
  },
  fi: {
    "/pro": LogoSometurvaPro,
    "/pro/trainings": LogoSometurvaPro,
    "/pro/onboarding": LogoSometurvaPro,
  },
}

export const getFooterLogoByCountry = () => footerLogoByCountry[siteCountry]

export const removeLocaleFromPath = (path, locale) =>
  path.replace(`/${locale}`, "")

export const getCustomLogo = (path, locale) => {
  return headerLogoByRoute?.[siteCountry]?.[removeLocaleFromPath(path, locale)]
}

export const getCustomFooterLogo = (path, locale) => {
  return footerLogoByRoute?.[siteCountry]?.[removeLocaleFromPath(path, locale)]
}

export const getLogoLink = (path, locale) => {
  const normalizedPath = removeLocaleFromPath(path, locale)
  const annualReportRoutes = new Set([
    "/schools/annual-reports",
    "/schools/annual-reports/",
    "/schools/annual-reports/2025",
    "/schools/annual-reports/2025/",
  ])

  if (annualReportRoutes.has(normalizedPath)) {
    return "/"
  }

  return (
    normalizedPath
      .split("/")
      .filter((el, index, arr) => index < arr.length - 2)
      .join("/") || "/"
  )
}
